import { DegreeType } from "../types/general";
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';

import { BINARY_COURSES_NUM, PTOR_NEKUDOT_ZCHOOT } from "./config";

const moment = extendMoment(Moment);

export const SEMESTER_A_24_25_START_DATE = moment('2024-10-29')
export const SEMESTER_A_24_25_END_DATE = moment('2025-03-19')
export const SEMESTER_A_24_25_PERIOD = moment.range(SEMESTER_A_24_25_START_DATE, SEMESTER_A_24_25_END_DATE).snapTo('day');

export const SEMESTER_B_24_25_START_DATE = moment('2025-03-20')
export const SEMESTER_B_24_25_END_DATE = moment('2025-10-18')
export const SEMESTER_B_24_25_PERIOD = moment.range(SEMESTER_B_24_25_START_DATE, SEMESTER_B_24_25_END_DATE);

export const YEAR_24_25_PERIOD = moment.range(SEMESTER_A_24_25_START_DATE, SEMESTER_B_24_25_END_DATE);

export const BEFORE_24_25_THREE_MONTHS = moment.range(moment('2024-07-29'), moment('2024-10-29'))

export enum Periods {
    IN_ONE_SEMESTER_21_DAYS = 1,
    IN_YEAR_35_DAYS,
    IN_ONE_SEMESTER_35_DAYS,
    IN_ONE_SEMESTER_50_DAYS,
    IN_YEAR_100_DAYS,
}

// There is no difference between "in Miluim" and "Bney zoog" in 2024-2025
export const RightsConfig = new Map(
    [
        [DegreeType.Boger, new Map(
            [
                [Periods.IN_ONE_SEMESTER_21_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 6],
                        [BINARY_COURSES_NUM, 2]
                    ]
                )],
                [Periods.IN_YEAR_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 6],
                        [BINARY_COURSES_NUM, 2]
                    ]
                )],
                [Periods.IN_ONE_SEMESTER_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 8],
                        [BINARY_COURSES_NUM, 3]
                    ]
                )],
                [Periods.IN_YEAR_100_DAYS, new Map(
                    [
                        [BINARY_COURSES_NUM, 6]
                    ]
                )],
            ]
        )],
        [DegreeType.Musmach, new Map(
            [
                [Periods.IN_ONE_SEMESTER_21_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 1]
                    ]
                )],
                [Periods.IN_YEAR_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 1]
                    ]
                )],
                [Periods.IN_ONE_SEMESTER_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 2]
                    ]
                )],
                [Periods.IN_YEAR_100_DAYS, new Map(
                    [
                        [BINARY_COURSES_NUM, 0]
                    ]
                )],
            ]
        )],
        [DegreeType.RefuaChishuvit, new Map( // double degree
            [
                [Periods.IN_ONE_SEMESTER_21_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 9],
                        [BINARY_COURSES_NUM, 3]
                    ]
                )],
                [Periods.IN_YEAR_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 9],
                        [BINARY_COURSES_NUM, 3]
                    ]
                )],
                [Periods.IN_ONE_SEMESTER_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 12],
                        [BINARY_COURSES_NUM, 5]
                    ]
                )],
                [Periods.IN_YEAR_100_DAYS, new Map(
                    [
                        [BINARY_COURSES_NUM, 9]
                    ]
                )],
            ]
        )],
        [DegreeType.BschoolMusmach, new Map(
            [
                [Periods.IN_ONE_SEMESTER_21_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 1]
                    ]
                )],
                [Periods.IN_YEAR_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 1]
                    ]
                )],
                [Periods.IN_ONE_SEMESTER_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 2]
                    ]
                )],
                [Periods.IN_YEAR_100_DAYS, new Map(
                    [
                        [BINARY_COURSES_NUM, 0]
                    ]
                )],
            ]
        )],
        [DegreeType.BschoolMaslulMuatz, new Map(
            [
                [Periods.IN_ONE_SEMESTER_21_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 1]
                    ]
                )],
                [Periods.IN_YEAR_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 1]
                    ]
                )],
                [Periods.IN_ONE_SEMESTER_35_DAYS, new Map(
                    [
                        [PTOR_NEKUDOT_ZCHOOT, 4],
                        [BINARY_COURSES_NUM, 2]
                    ]
                )],
                [Periods.IN_YEAR_100_DAYS, new Map(
                    [
                        [BINARY_COURSES_NUM, 0]
                    ]
                )],
            ]
        )]
    ]
)

export const MaxZcootConfig = new Map(
    [
        [DegreeType.Boger, new Map(
            [
                [PTOR_NEKUDOT_ZCHOOT, 10],
                [BINARY_COURSES_NUM, 6]
            ],
        )],
        [DegreeType.Musmach, new Map(
            [
                [PTOR_NEKUDOT_ZCHOOT, 4],
                [BINARY_COURSES_NUM, 4]
            ],
        )],
        [DegreeType.RefuaChishuvit, new Map( // double degree
            [
                [PTOR_NEKUDOT_ZCHOOT, 14],
                [BINARY_COURSES_NUM, 9]
            ],
        )],
        [DegreeType.BschoolMusmach, new Map(
            [
                [PTOR_NEKUDOT_ZCHOOT, 4],
                [BINARY_COURSES_NUM, 4]
            ],
        )],
        [DegreeType.BschoolMaslulMuatz, new Map(
            [
                [PTOR_NEKUDOT_ZCHOOT, 4],
                [BINARY_COURSES_NUM, 4]
            ],
        )]
    ]
);
